<template>
    <div>
        <div v-if="!contentLoaded">
            <loading v-bind:dspin="!contentLoaded"></loading>
        </div>

        <div v-else class="w3-animate-opacity">
            <h3 class="flow-blue-color zero-bottom flow-form-title zero">
                <b>{{ fullUserName }}</b>
                <span>
                    <span class="flow-margin-left" v-if="user.username || user.language">
                        {{ (user.username ? ('(' + user.username + ')') : '') + (null != user.language ? ' ' + (' - '+user.language) : '') }}
                    </span>
                </span>
            </h3>
            <span class="w3-margin-top flow-blue-color w3-large">
                {{user.email}}
            </span>
            <span class="w3-padding">
                <user-role :role="user.role"></user-role>
            </span>

            <!--User delete screens-->
            <div v-if="showDelWarning" class="w3-content w3-center w3-margin-top w3-margin-bottom">
                <h4>{{$t('delete')}} <span class="w3-text-red"><b>{{ fullUserName }}</b></span>? </h4>
                <div>
                    <button class="flow-btn w3-btn w3-round w3-border w3-ripple w3-round-medium w3-margin-right w3-margin-top w3-large"
                            @click.prevent="deleteUser">
                        <i class="fa fa-trash w3-text-red">
                            <span><b class="flow-margin-left">{{$t('yes')}}</b></span>
                        </i>
                    </button>

                    <button class="flow-btn w3-btn w3-round w3-border w3-ripple w3-round-medium w3-margin-top w3-large"
                            @click="showDelWarning = false">
                        <i class="fa fa-times flow-blue-color">
                            <span><b class="flow-margin-left">{{$t('no')}}</b></span>
                        </i>
                    </button>
                </div>
            </div>

            <form v-else class="flow-form-cum-panel w3-col">
                <div class="w3-margin-top">
                    <!--<div class="w3-container">-->
                        <!--<p class="w3-col w-50pc flow-form-inline-input w3-margin-top">-->
                            <!--<label class="w3-left flow-blue-color w-100pc flow-margin-bottom">{{ $t("role") }}</label>-->

                            <!--<label v-for="role in allRoles"-->
                                   <!--class="flow-radio w3-col w-25pc w3-left w3-ripple">-->
                                <!--<input class="w3-input" type="radio" name="role" v-bind:value="role" v-model="user.role"/>-->
                                <!--<span class="name w3-margin-left">-->
                                    <!--<user-role :role="role"></user-role>-->
                                <!--</span>-->
                                <!--<i class="dot far fa-dot-circle"></i>-->
                            <!--</label>-->
                        <!--</p>-->
                    <!--</div>-->

                    <div v-if="showWardSelect" class="w3-container">
                        <p class="w3-col w-100pc flow-form-inline-input">
                            <label class="w3-left flow-blue-color flow-padding-bottom w-100pc">{{ $t("wards") }}</label>
                            <label v-for="ward in allWards" class="flow-radio w3-col w-20pc w3-left w3-ripple w3-padding-16 zero-top">
                                <input class="w3-input" type="checkbox" v-bind:value="ward.id" v-model="selectedWardIds"/>
                                <span class="name w3-margin-left flow-padding-left">{{ ward.displayName }}</span>
                                <i class="square fa fa-check w3-margin-right"></i>
                            </label>
                        </p>
                    </div>

                    <!--IF THERE IS ALREADY A PHYSICIAN ASSOCIATED TO THIS USER-->
                    <div v-if="user.physician" class="w3-container w3-margin-left">
                        <div class="flow-card w-90pc flow-padding-bottom"
                             v-bind:class="isAGSPhysicianDeleted ? 'red-top' : 'blue-top'">
                            <header class="w3-container flow-blue-color flow-margin-top physician-card flow-padding">
                                <div class="flow-padding flow-margin-bottom">
                                    <i class="fa fa-user-md flow-margin-right"></i>
                                    {{ user.physician.name }}
                                    <span v-if="user.physician.ward" class="flow-margin-left flow-badge w3-round-medium font-weight-bold">
                                    {{ user.physician.ward.displayName }}
                                </span>
                                </div>
                            </header>
                            <div class="w3-container w3-margin-top">
                                <div v-if="!isAGSPhysicianDeleted" class="w3-col w-80pc">
                                    <div class="w3-margin-bottom">
                                        <input v-for="(agsId, index) in newRefs"
                                               v-model="newRefs[index]"
                                               v-bind:disabled="user.agendaSystemPhysician === false"
                                               class="w3-input w-30pc"/>
                                        <input v-if="user.agendaSystemPhysician && newRefs.length === 0"
                                               v-model="newRefs[0]"
                                               class="w3-input w-30pc"/>
                                    </div>
                                </div>
                                <div v-else class="w3-col w-100pc w3-center">
                                    <h6 class="flow-blue-color font-weight-bold">{{$t('physicianHasBeenRemoved')}}</h6>
                                </div>
                            </div>
                            <div class="w3-container flow-padding-bottom">
                                <button v-if="!user.agendaSystemPhysician && !isAGSPhysicianDeleted"
                                        class="flow-btn w3-btn w3-round w3-border w3-ripple w3-round-medium w3-left flow-margin-bottom w3-margin-right"
                                        @click.prevent="claimPhysician">
                                    <i class="fa fa-link flow-blue2-text"></i>
                                    <span><b class="flow-margin-left">{{$t('setUserAsAgendaPhysician')}}</b></span>
                                </button>
                                <button class="flow-btn w3-btn w3-round w3-border w3-ripple w3-round-medium w3-left flow-margin-bottom"
                                        @click.prevent="unlinkPhysician">
                                    <i class="fa fa-unlink flow-orange-text"></i>
                                    <span><b class="flow-margin-left">{{$t('unlinkASP')}}</b></span>
                                </button>
                            </div>
                        </div>
                    </div>

                    <!--IF THERE IS NO PHYSICIAN ASSOCIATED, LET'S ASK IF THEY WOULD LIKE TO BE ASSOCIATED WITH ONE OR CREATE NEW ONE-->
                    <div v-else class="zero">
                        <div class="w3-container">
                            <p class="w3-col w-100pc flow-form-inline-input">
                                <label class="w3-container zero w3-left flow-blue-color flow-margin-right">{{$t('isUserASP')}}?</label>

                                <label class="flow-radio w3-col w-auto w3-left w3-ripple">
                                    <input class="w3-input" type="radio" name="isAGSPhysician" v-bind:value=true v-model="isAGSPhysician"/>
                                    <span class="name w3-margin-left">{{$t('yes')}}</span>
                                    <i class="dot far fa-dot-circle"></i>
                                </label>
                                <label class="flow-radio w3-col w-auto w3-left w3-ripple">
                                    <input class="w3-input" type="radio" name="isAGSPhysician" v-bind:value=false v-model="isAGSPhysician"/>
                                    <span class="name w3-margin-left">{{$t('no')}}</span>
                                    <i class="dot far fa-dot-circle"></i>
                                </label>
                            </p>
                        </div>

                        <!--USER ASKED TO CREATE A NEW PHYSICIAN, LET'S SHOW THEM THE FORM-->
                        <div v-if="isAGSPhysician" class="w3-container zero-top">

                            <p class="w3-col flow-form-inline-input font-weight-bold">
                                <label class="flow-blue-color flow-padding-bottom">{{ $t('selectOrAddPhysician') }}</label>
                            </p>


                            <p class="w3-col w-70pc flow-form-inline-input">
                                <label class="w3-left flow-blue-color flow-padding-bottom">{{ $t('option') }} 1: {{$t('select.physician')}}</label>
                                <flow-select :items="allPhysicians" :valueKey="'name'" :valueKeyIndex="'id'"
                                             :callback="agendaSystemPhysicianSelected"></flow-select>
                            </p>

                            <p class="w3-col flow-form-inline-input">
                                <label class="flow-blue-color flow-padding-bottom">{{ $t('option') }} 2: {{ $t('addNewPhysician') }}</label>
                            </p>


                            <p class="w3-col w-45pc flow-form-inline-input w3-left zero-bottom">
                                <label class="w3-left flow-blue-color flow-padding-bottom">{{ $t("screenName") }}</label>
                                <input class="w3-input" v-bind:class="snameError ? 'error' : ''" type="text" v-bind:placeholder="$t('enter.screenName')" v-model="screenName">
                                <span class="w3-text-red"> {{ snameError }} </span>
                            </p>
                            <p class="w3-col w-45pc flow-form-inline-input w3-right">
                                <label class="w3-left flow-blue-color flow-padding-bottom">{{ $t("externalId") }}</label>
                                <input class="w3-input" v-bind:class="refError ? 'error' : ''" type="text" v-bind:placeholder="$t('enter.externalId')" v-model="newRefs[0]">
                                <span class="w3-text-red"> {{ refError }} </span>
                            </p>
                            <div class="w3-container zero-left">
                                <p class="w3-col w-45pc flow-form-inline-input w3-left w3-margin-top zero-bottom">
                                    <label class="w3-left flow-blue-color flow-padding-bottom">{{$t('ward')}}</label>
                                    <flow-select :items="allWards" :valueKey="'displayName'" :valueKeyIndex="'id'" :callback="workingWardSelected"></flow-select>
                                </p>
                            </div>
                        </div>

                        <!--THE USER SAYS THEY ARE NOT A 'PHYSICIAN', BUT IS A 'NORMAL' USER, SO LET'S ASK THEM MAKE A SELECTION FROM THE LIST OF PHYSICIANS-->
                        <div v-if="showPhysicianSelect" class="w3-container zero-top" onload="getAllPhysicians()">
                            <p class="w3-col w-70pc flow-form-inline-input">
                                <label class="w3-left flow-blue-color flow-padding-bottom">{{$t('select.physician')}}</label>
                                <flow-select :items="allPhysicians" :valueKey="'name'" :valueKeyIndex="'id'"
                                             :callback="agendaSystemPhysicianSelected"></flow-select>
                            </p>
                        </div>
                    </div>

                    <div class="w3-container zero-top">
                        <p class="flow-form-inline-input">
                            <button class="flow-btn w3-btn w3-round w3-border w3-ripple w3-round-medium w3-left w3-margin-right w3-margin-top w3-large"
                                    @click.prevent="validateAndSave">
                                <i class="fa fa-save flow-green-active-color">
                                    <span><b class="flow-margin-left">{{$t('save')}}</b></span>
                                </i>
                            </button>

                            <button class="flow-btn w3-btn w3-round w3-border w3-ripple w3-round-medium w3-right w3-margin-top w3-large"
                                    @click.prevent="showDelWarning = true">
                                <i class="fa fa-trash w3-text-red">
                                    <span><b class="flow-margin-left">{{$t('delete')}}</b></span>
                                </i>
                            </button>
                        </p>
                    </div>
                </div>
            </form>

        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import ContentHeader from "../components/common/ContentHeader";
    import Loading from "../components/common/Loading";
    import UserRole from "../components/common/UserRole";
    import FlowSelect from "../components/common/FlowSelect";
    import { EventBus } from "../main"

    let frc = Vue.prototype.$frc;

    export default {
        name: "User",
        components: {FlowSelect, UserRole, Loading, ContentHeader},
        props: ['userId'],
        data() {
            return {
                contentLoaded: false,
                user: {
                    firstName: '',
                    lastName: '',
                    role: undefined,
                    username: ''
                },
                lwWards: [],
                allWards: [],
                allRoles: [],
                selectedWardIds: [],
                isAGSPhysician: false,
                AGSPhysicianId: undefined,
                screenName: undefined,
                newRefs: [],
                refError: undefined,
                snameError: '',
                workingWardId: undefined,
                allPhysicians: [],
                allPhysiciansFirstItem: {id: -1, name: this.$t("none")},
                showDelWarning: false
            }
        },
        beforeCreate() {
            var app = this;
            frc.getWards().then(function(res) {
                var wards = res.data;
                app.allWards = [];

                for (let i = 0; i < wards.length; i++) {
                    const w = wards[i];
                    app.allWards.push(w);
                }

                Vue.sortByKey(app.allWards, 'displayName');

                frc.getRoles().then(function(res) {
                    let roles  = res.data;
                    app.allRoles = [];
                    for (let idx in roles) {
                        if (roles[idx]) {
                            app.allRoles.push(roles[idx].value);
                        }
                    }
                });
            });
        },
        created() {
            this.init();
        },
        mounted() {
            this.getUserFullOverview();
            this.getAllPhysicians();
            EventBus.$on("userIdUpdated", this.getUserFullOverview);
            EventBus.$on("userIdUpdated", this.getAllPhysicians);
        },
        beforeDestroy() {
            EventBus.$off("userIdUpdated", this.getUserFullOverview);
            EventBus.$off("userIdUpdated", this.getAllPhysicians);
        },
        watch: {
            userId() {
                this.init();
                this.getUserFullOverview();
            },
            lwWards(newWards, oldWards) {
                if (!newWards) {
                    return;
                }
                this.selectedWardIds = [];
                if (!Vue.isPower(this.user.role)) {
                    return;
                }
                newWards.forEach(w => {
                    this.selectedWardIds.push(w.id);
                });
            }
        },
        computed: {
            showWardSelect() {
                return Vue.isPower(this.user.role);
            },
            showPhysicianSelect() {
                if (this.isAGSPhysician === false && Vue.isNormal(this.user.role)) {
                    this.getAllPhysicians();
                    return true;
                }

                return false;
            },
            fullUserName() {
                return this.user.firstName + " " + this.user.lastName;
            },
            isAGSPhysicianDeleted() {
                return this.user.physician && this.user.physician.status === 'Deleted';
            },
        },
        methods: {
            init() {
                this.user = {
                    firstName: '',
                    lastName: '',
                    role: undefined,
                    username: ''
                };
                this.lwWards = [];
                this.selectedWardIds = [];
                this.isAGSPhysician = false;
                this.AGSPhysicianId = undefined;
                this.screenName = undefined;
                this.newRefs = [];
                this.refError = undefined;
                this.snameError = '';
                this.workingWardId = undefined;
                // this.allPhysicians = [];
                this.contentLoaded = false;
                this.showDelWarning = false;
            },
            getUserFullOverview() {
                var app = this;
                this.init();
                frc.getUserFullOverview(this.userId).then(function(res) {
                    var overview = res.data;
                    app.user = overview.user;
                    app.user.username = overview.username;
                    app.lwWards = overview.lwWards;

                    if (app.user.physician) {
                        app.newRefs = JSON.parse(JSON.stringify(app.user.physician.agendaSystemIds));
                    }
                    app.contentLoaded = true;
                }).catch(function(ex) {
                    app.contentLoaded = true;
                });
            },
            validateAndSave() {
                this.save();
            },
            save() {
                this.contentLoaded = false;
                var wardIds = null;
                this.snameError = undefined;
                this.refError = undefined;
                if (Vue.isPower(this.user.role)) {
                    wardIds = this.selectedWardIds;
                }

                if (!this.user.physician) {
                    if (this.isAGSPhysician === true) {
                        this.user.agendaSystemPhysician = true;

                        if (this.AGSPhysicianId) {
                            this.user.agendaSystemPhysicianId = this.AGSPhysicianId;
                            this.newRefs = undefined;
                        } else if (!this.screenName || !this.screenName.trim()) {
                            this.snameError = this.$t("INVALID_INPUT");
                            this.contentLoaded = true;
                            return;
                        }

                        this.saveUser(this.userId, this.user, undefined, this.newRefs, this.screenName, this.workingWardId);
                        return;
                    }

                    if (Vue.isNormal(this.user.role) && this.AGSPhysicianId) {
                        this.user.agendaSystemPhysician = false;
                        this.user.agendaSystemPhysicianId = this.AGSPhysicianId;
                        this.saveUser(this.userId, this.user, undefined, undefined, undefined, undefined);
                        return;
                    }
                }

                var addNewRefs = false;
                for (var nRef in this.newRefs) {
                    if (!this.user.physician.agendaSystemIds.includes(nRef)) {
                        addNewRefs = true;
                        break;
                    }
                }

                this.saveUser(this.userId, this.user, wardIds, addNewRefs ? this.newRefs : undefined, null, null);
            },
            unlinkPhysician() {
                var user = this.user;
                user.agendaSystemPhysician = false;
                user.agendaSystemPhysicianId = null;

                this.saveUser(this.userId, user, null, null, null, null);
            },
            claimPhysician() {
                var user = this.user;
                user.agendaSystemPhysician = true;

                this.saveUser(this.userId, user, null, null, null, null);
            },
            saveUser(userId, user, wardIds, references, screenName, workingWardId) {
                var app = this;
                app.contentLoaded = false;
                frc.updateUserFullOverview(userId, user, wardIds, references, screenName, workingWardId).then(function(res) {
                    EventBus.$emit("userIdUpdated", userId);
                    Vue.notifySuccess({title: app.$t("success"), message: app.$t("profileUpdated")});
                    app.contentLoaded = true;
                }).catch(function(ex) {
                    app.contentLoaded = true;
                    if (!ex.restCodes) {
                        return;
                    }

                    if (ex.restCodes.includes("INVALID_REFERENCES") || ex.restCodes.includes("AGENDA_SYSTEM_REFERENCES_EXISTS")) {
                        app.refError = app.$t(ex.restCodes);
                    }
                });
            },
            deleteUser: function() {
                let app = this;
                app.contentLoaded = false;
                app.showDelWarning = false;
                var id = this.userId;
                frc.deleteUser(id)
                    .then(function (res) {
                        app.showUserDeletionConfirmed = true;
                        app.contentLoaded = true;
                        EventBus.$emit("userIdDeleted", id);
                        Vue.notifySuccess({title: app.$t('success'),message: app.$t('user') + " <strong>" + app.fullUserName +"</strong> " + app.$t('deleted')});
                    });
            },
            workingWardSelected(ward) {
                this.workingWardId = ward.id;
            },
            getAllPhysicians() {
                var app = this;
                frc.getAllPhysicians().then(function (res) {
                    app.allPhysicians = [];
                    app.allPhysicians.push(app.allPhysiciansFirstItem);
                    var physicians = res.data;
                    for (var i = 0; i < physicians.length; i++) {
                        var phy = physicians[i];
                        var name = phy.name;
                        if (phy.ward) {
                            name += " - " + phy.ward.displayName;
                        }
                        if (phy.agendaSystemIds && phy.agendaSystemIds.length > 0) {
                            name += " - " + phy.agendaSystemIds.join(",");
                        }

                        app.allPhysicians.push({
                            id: phy.id, name: name
                        });
                    }
                });
            },
            agendaSystemPhysicianSelected(physician) {
                this.AGSPhysicianId = physician.id === -1 ? undefined : physician.id;
            }


        }
    }
</script>

<style scoped>
</style>